export default "__VITE_PUBLIC_ASSET__f4a0f247__"